/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Sub_Categories_LabelInputs */

const en_common_header_explore_sub_categories_label = /** @type {(inputs: Common_Header_Explore_Sub_Categories_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sub-categories`)
};

const zh_common_header_explore_sub_categories_label = /** @type {(inputs: Common_Header_Explore_Sub_Categories_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`子分类`)
};

/**
* | output |
* | --- |
* | "Sub-categories" |
*
* @param {Common_Header_Explore_Sub_Categories_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_sub_categories_label = /** @type {((inputs?: Common_Header_Explore_Sub_Categories_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Sub_Categories_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_sub_categories_label(inputs)
	return zh_common_header_explore_sub_categories_label(inputs)
});
export { common_header_explore_sub_categories_label as "common.header.explore.sub_categories.label" }